<template>
    <div class="portfolio-item" @click="goto()">
        <div class="portfolio-content">
            <img :src="data.image" />
            <h3>
                {{data.title}}
            </h3>
        </div>
        <div class="portfolio-top-left-radius portfolio-radius"></div>
        <div class="portfolio-top-right-radius portfolio-radius"></div>
        <div class="portfolio-bottom-left-radius portfolio-radius"></div>
        <div class="portfolio-bottom-right-radius portfolio-radius"></div>
    </div>
</template>

<script>
export default {
  props: ['data'],
  methods: {
    goto () {
      const dest = (this.data.route ? this.data.route : '/p/' + this.data.id)
      this.$router.push({path: dest})
    }
  }
}
</script>

<style>
.portfolio-item {
    float: none;
    margin: 20px auto;
    max-width: 290px;
    background: #fff4da;
    box-shadow: 0 0 3px #444444;
    padding: 6px;
    position: relative;
}
.portfolio-content {
    /* height: auto; */
    max-width: 290px;
    width: 100%;
    height: 160px;
}
.portfolio-content h3 {
    background: left top repeat url(//naranzug.ip008.com/wp-content/themes/timeturner/images/portfolio-headline.png);
    color: white;
    font-family: "Arial Narrow", Arial, sans-serif;
    font-size: 16px;
    font-weight: normal;
    height: 35px;
    line-height: 35px;
    max-width: 290px;
    position: absolute;
    bottom: 0px;
    left: 6px;
    text-align: center;
    width: 100%;
    margin-bottom: 6px;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
}
.portfolio-radius {
    background: #fff4da;
    height: 10px;
    position: absolute;
    width: 10px;
    z-index: 20;
}
.portfolio-box .portfolio-top-left-radius {
    -webkit-border-bottom-right-radius: 10px;
    -moz-border-radius-bottomright: 10px;
    border-bottom-right-radius: 10px;
    top: 6px;
    left: 6px;
}
.portfolio-box .portfolio-top-right-radius {
    -webkit-border-bottom-left-radius: 10px;
    -moz-border-radius-bottomleft: 10px;
    border-bottom-left-radius: 10px;
    top: 6px;
    right: 6px;
}
.portfolio-box .portfolio-bottom-left-radius {
    -webkit-border-top-right-radius: 10px;
    -moz-border-radius-topright: 10px;
    border-top-right-radius: 10px;
    bottom: 6px;
    left: 6px;
}
.portfolio-box .portfolio-bottom-right-radius {
    -webkit-border-top-left-radius: 10px;
    -moz-border-radius-topleft: 10px;
    border-top-left-radius: 10px;
    bottom: 6px;
    right: 6px;
}
.portfolio-item img {
    width: 290px;
}
</style>



// WEBPACK FOOTER //
// src/components/templates/PortfolioItem.vue